import { render, staticRenderFns } from "./FooterButton.pug?vue&type=template&id=316c9b5e&scoped=true&lang=pug&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"
import style0 from "./FooterButton.scss?vue&type=style&index=0&id=316c9b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c9b5e",
  null
  
)

export default component.exports